import { api, authHeader } from "../configs/axiosConfigs";

/**
 * Shared map-link / coordinate parser.
 * Uses role-agnostic Map endpoint so operators/partners/customers all work
 * (customer assisted-registration route is CustomerOnly and returns 403 for other roles).
 */
const parseLocationApi = async (locationInput) => {
  const response = await api.request({
    url: `Map/Geocoding/ParseLocation`,
    method: "POST",
    data: { locationInput },
    headers: authHeader(),
  });
  const res = response.data;
  const isSuccess = res?.isSuccess ?? res?.IsSuccess;
  if (!isSuccess) {
    return {
      isSuccess: false,
      data: null,
      message: res?.message ?? res?.Message ?? "خطا در پردازش موقعیت.",
    };
  }
  return {
    isSuccess: true,
    data: res?.data ?? res?.Data ?? null,
    message: res?.message ?? res?.Message,
  };
};

export default parseLocationApi;
